var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyReportsDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16175_105691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5917 7.36667V0.5H0V36.9417C0.00073444 37.8847 0.375484 38.7889 1.04204 39.456C1.7086 40.1231 2.61253 40.4985 3.55556 40.5H36.4444C37.3875 40.4985 38.2914 40.1231 38.958 39.456C39.6245 38.7889 39.9993 37.8847 40 36.9417V7.36667H34.5917ZM3.55556 38.7972C3.06391 38.7965 2.59266 38.6007 2.24528 38.2528C1.89789 37.9049 1.70278 37.4333 1.70278 36.9417V2.20278H32.8889V36.9417C32.8883 37.5965 33.0691 38.2388 33.4111 38.7972H3.55556ZM38.2972 36.9417C38.2972 37.4331 38.102 37.9043 37.7546 38.2518C37.4071 38.5992 36.9358 38.7944 36.4444 38.7944C35.9531 38.7944 35.4818 38.5992 35.1343 38.2518C34.7869 37.9043 34.5917 37.4331 34.5917 36.9417V9.06944H38.2972V36.9417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7695 8.90552H4.82227V10.6083H29.7695V8.90552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9112 14.4529H4.82227V16.1557H15.9112V14.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9112 20H4.82227V21.7028H15.9112V20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9112 25.5471H4.82227V27.2499H15.9112V25.5471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9112 31.0945H4.82227V32.7973H15.9112V31.0945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8306 32.7972H30.6083V14.4639H17.8306V32.7972ZM19.5333 16.1555H28.9195V31.0944H19.5333V16.1555Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16175_105691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReportsDashboard);
export default __webpack_public_path__ + "static/media/my-reports-dashboard.66a261e64c1b3e8c1039a362caa40095.svg";
export { ForwardRef as ReactComponent };